<div class="flex flex-col justify-between flex-auto items-center">
    
    <!-- Logo -->
    <app-startup-logo></app-startup-logo>
    
    <div class="start-up-form-container">
        <!-- <div class="mx-auto w-full max-w-80 sm:mx-0 sm:w-80"> -->
        <div class="min-w-full">

            <!-- Title -->
            <div class="start-up-title"> Forgot password? </div>
            <!-- <div class="mt-0.5 font-medium">
                Fill the form to reset your password
            </div> -->

            <!-- Alert -->
            @if (showAlert) {
                <fuse-alert
                    class="mt-2"
                    [appearance]="'outline'"
                    [showIcon]="false"
                    [type]="alert.type"
                    [@shake]="alert.type === 'error'"
                >
                    {{ alert.message }}
                </fuse-alert>
            }

            <!-- Forgot password form -->
            <form
                class="mt-3"
                [formGroup]="forgotPasswordForm"
                #forgotPasswordNgForm="ngForm"
            >
                <!-- Email field -->
                <mat-form-field class="mat-form-field-cleaner">
                    <mat-label class="font-bold text-md">Email</mat-label>
                    <input 
                        class="input"
                        id="email" 
                        matInput 
                        [formControlName]="'email'" 
                    />
                    @if (forgotPasswordForm.get('email').hasError('required')) {
                        <mat-error> Email address is required </mat-error>
                    }
                    @if (forgotPasswordForm.get('email').hasError('email')) {
                        <mat-error>
                            Please enter a valid email address
                        </mat-error>
                    }
                </mat-form-field>

                <div class="sho-label text-md font-bold py-3">
                    We have send an email with the information about your credentials reset. Follow this instructions for get a new password.
                </div>

                <!-- Submit button -->
                <button
                    class="btn btn-primary btn-login mt-4"
                    [disabled]="forgotPasswordForm.disabled"
                    (click)="sendResetCode()"
                >
                    @if (!forgotPasswordForm.disabled) {
                        <!-- <span> Send reset link </span> -->
                        <span class="flex-auto text-xl"> Send Recovery </span>
                    }
                    @if (forgotPasswordForm.disabled) {
                        <mat-progress-spinner
                            class="mx-auto"
                            [diameter]="24"
                            [mode]="'indeterminate'"
                        ></mat-progress-spinner>
                    }
                </button>

                <!-- Form footer -->
                <!-- <div class="text-secondary mt-8 text-md font-medium">
                    <span>Return to</span>
                    <a
                        class="ml-1 text-primary-500 hover:underline"
                        [routerLink]="['/sign-in']"
                        >sign in
                    </a>
                </div> -->
            </form>
        </div>
    </div>

    <!-- Copyright -->
    <app-copyright></app-copyright>
</div>